import { ESuit } from '@pushflow/types/poker/enums'
import { ESuitSymbol } from '../enums'

export const suitSymbolByLetter: Record<ESuit, ESuitSymbol> = {
  [ESuit.CLUB]: ESuitSymbol.CLUB,
  [ESuit.DIAMOND]: ESuitSymbol.DIAMOND,
  [ESuit.HEART]: ESuitSymbol.HEART,
  [ESuit.SPADE]: ESuitSymbol.SPADE,
}
